import React from 'react';
import { AlertCircle } from 'lucide-react';
import { cn } from 'lib/utils';

export interface ExamStateCardProps {
    /** `warning` for a blocked-but-fixable start (subscription), `error` for an unavailable test. */
    tone: 'warning' | 'error';
    title: string;
    message: string;
    /** Buttons, secondary first: they sit right-aligned on wide screens and stack (primary on top) on phones. */
    actions: React.ReactNode;
}

/** Full-page notice for runner states the boards don't draw (test unavailable, subscription needed). */
export function ExamStateCard({ tone, title, message, actions }: ExamStateCardProps) {
    return (
        <div
            data-surface="exam"
            className="flex min-h-screen items-start justify-center bg-[#F4F5F7] px-4 py-12 text-foreground dark:bg-background sm:items-center sm:p-6"
        >
            <article className="w-full max-w-[448px] rounded-lg border border-border bg-card p-6 sm:p-7">
                <div className="flex gap-3">
                    <AlertCircle
                        className={cn(
                            'mt-0.5 h-5 w-5 shrink-0',
                            tone === 'warning' ? 'text-warning-600' : 'text-error-600',
                        )}
                        aria-hidden
                    />
                    <div className="flex min-w-0 flex-col gap-1.5">
                        <h1 className="text-lg font-semibold">{title}</h1>
                        <p className="text-[14.5px] leading-relaxed text-muted-foreground">{message}</p>
                    </div>
                </div>
                <div className="mt-6 flex flex-col-reverse gap-2.5 sm:flex-row sm:justify-end">{actions}</div>
            </article>
        </div>
    );
}

export default ExamStateCard;
